import { authentication } from '@microsoft/teams-js';

import { AcquireTokenAuthError } from '../errors';
import { getTokenExpirationTimeInSeconds } from '../jwt';

import { ensureInitialized } from './initialize';

const maxTokenCacheTimeToLiveInSeconds = 60 * 10;
const expirationOffsetInSeconds = 30; // Used to prevent caching tokens which will expire in <= 30s

type GetTokenCacheTimeToLive = (token: string) => number | undefined;
export const getTokenCacheTimeToLive: GetTokenCacheTimeToLive = (token) => {
  try {
    const tokenExpirationTimeInSeconds = getTokenExpirationTimeInSeconds(token) - expirationOffsetInSeconds;
    const tokenCacheTimeToLiveInSeconds = tokenExpirationTimeInSeconds - Math.round(Date.now() / 1000.0);

    return Math.min(maxTokenCacheTimeToLiveInSeconds, tokenCacheTimeToLiveInSeconds);
  } catch (error) {
    return undefined;
  }
};

type GetAuthToken = (resource: string, claims?: string[]) => Promise<string>;
export const getAuthToken: GetAuthToken = async (resource, claims) => {
  await ensureInitialized();

  return authentication
    .getAuthToken({
      resources: [resource],
      claims,
    })
    .catch((error: string) => {
      throw new AcquireTokenAuthError({ errorCode: 'AuthAcquireTokenFailed', errorMessage: error });
    });
};
